"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actionsFirebase = require("../actions/firebase");

var unsubscribe = function unsubscribe(state) {
  return function (localBinding) {
    var firebaseRefs = state.firebaseRefs;
    var firebaseListeners = state.firebaseListeners;
    var firebasePopulated = state.firebasePopulated;
    var store = state.store;

    var ref = firebaseRefs[localBinding];
    var listeners = firebaseListeners[localBinding];
    var populated = firebasePopulated[localBinding];

    Object.keys(listeners).forEach(function (event) {
      if (listeners.hasOwnProperty(event)) {
        ref.off(event, listeners[event]);
      }
    });

    // cancel change listeners for populated refs
    Object.keys(populated).forEach(function (key) {
      populated[key].ref.off("value", populated[key].listener);
    });

    // cleanup ref, listeners and populated
    delete firebaseRefs[localBinding];
    delete firebaseListeners[localBinding];
    delete firebasePopulated[localBinding];

    // reset store value to null
    store.dispatch((0, _actionsFirebase.replaceValue)(localBinding, null));
  };
};

exports["default"] = unsubscribe;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/refire/lib/syncFirebase/unsubscribe.js
// module id = 387
// module chunks = 0